import { render, staticRenderFns } from "./CmgNutritionCalculatorPrimaryBanner.vue?vue&type=template&id=592218ab&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-primary-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-primary-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorPrimaryBanner.vue?vue&type=style&index=0&id=592218ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592218ab",
  null
  
)

export default component.exports